<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid">
	<label>Student:</label>
	<label class="InfoText">{{ StudentName }}</label>

	<label>Student ID:</label>
	<label class="InfoText">{{ StudentID }}</label>

	<label>Current Balance:</label>
	<label class="InfoText">{{ CurrentBalance }}</label>

	<label>Point:</label>
	<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="SelectedPoint">
		<option *ngFor="let r of lstPoints" [ngValue]="r">
			{{ r.PointsItemDesc }}
		</option>
	</select>

	<label>Value:</label>
	<label class="InfoText">{{ SelectedPoint == undefined ? "" : SelectedPoint.PointsItemValue }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>
